// import React, { useState } from 'react'
// import { Form, Input, Button, Checkbox, notification } from 'antd'
// import loginImage from './6878430.png' // Import the image file
// import { Link } from 'react-router-dom' // Import Link from react-router-dom
// import './alumini.css'
// import axios from 'axios'
// import { useNavigate } from 'react-router-dom'
// import { MemberLoginApi } from '../../ApiFile'

// const StudentLogin = () => {
//   const [loading, setLoading] = useState(false)
//   const navigate = useNavigate()

//   const onFinish = (values) => {
//     setLoading(true)
//     const currentYear = new Date().getFullYear() // Get current year

//     axios
//       .post(MemberLoginApi, {
//         email: values.username,
//         password: values.password,
//         loginYear: currentYear,
//       })
//       .then((response) => {
//         setLoading(false)

//         if (response.data.status == 5) {
//           notification.warning({
//             message: 'Student is discharged!',
//           })
//           navigate('/StudentLogin')
//           return
//         } else if (response.data.message === 'Invalid Email_id') {
//           notification.error({
//             message: 'Invalid Email',
//           })
//           return
//         } else if (response.data.message === 'Invalid Password') {
//           notification.error({
//             message: 'Invalid Password',
//           })
//           return
//         }
//         if (response.data.message === 'Login Successful') {
//           sessionStorage.setItem('member_id', response.data.member_id)
//           sessionStorage.setItem('memberName', response.data.memberName)
//           sessionStorage.setItem('email', response.data.email)
//           sessionStorage.setItem('status', response.data.status)
//           sessionStorage.setItem('year', response.data.year)

//           if (response.data.status === 3) {
//             notification.warning({
//               message: 'Admin Approval Pending',
//               description: 'Wait for Admin Approval....',
//             })
//             navigate('/StudentLogin')
//           } else if (response.data.status === 4) {
//             notification.success({
//               message: 'Login Successfully !!!!!',
//             })
//             navigate('/BlockRoomBooking')
//           } else if (response.data.status === 7) {
//             notification.info({
//               message: 'Payment Approval Pending',
//               description: 'Admin payment approval is pending.',
//             })
//             navigate('/StudentLogin')
//           } else if (response.data.status === 8) {
//             sessionStorage.setItem('block_id', response.data.block_id)
//             sessionStorage.setItem('room_id', response.data.room_id)
//             sessionStorage.setItem('bed_id', response.data.bed_id)
//             notification.error({
//               message: 'Payment Rejected',
//               description: 'Your payment has been rejected. Please pay again.',
//             })
//             navigate('/PaymentRoomBooking')
//           } else if (response.data.status === 9) {
//             // notification.success({
//             //   message: "Payment Successful",
//             //   description: "Your payment was successful.",
//             // });
//             navigate('/Homestudent')
//           }
//         } else {
//           notification.error({
//             message: 'Login Failed',
//             description: 'Invalid email or password.',
//           })
//         }
//       })
//       .catch((error) => {
//         setLoading(false)
//         notification.error({
//           message: 'Login Failed',
//           description: 'Error logging in. Please try again.',
//         })
//       })
//   }

//   const onFinishFailed = (errorInfo) => {
//     // console.log("Failed:", errorInfo);
//   }

//   return (
//     <div className="login-page">
//       <div className="login-box" style={{ overflow: 'scroll' }}>
//         <div className="illustration-wrapper">
//           <img src={loginImage} alt="Login" /> {/* Use the imported image */}
//         </div>
//         <Form
//           name="login-form"
//           initialValues={{ remember: true }}
//           onFinish={onFinish}
//           onFinishFailed={onFinishFailed}
//         >
//           <p className="form-title">Student Login</p>
//           <p>Login to your student account</p>
//           <Form.Item
//             name="username"
//             rules={[{ required: true, message: 'Please input your Email ID!' }]}
//           >
//             <Input placeholder="Email ID" />
//           </Form.Item>

//           <Form.Item
//             name="password"
//             rules={[{ required: true, message: 'Please input your password!' }]}
//           >
//             <Input.Password placeholder="Password" />
//           </Form.Item>

//           <Form.Item>
//             <Button
//               type="primary"
//               htmlType="submit"
//               className="login-form-button"
//               loading={loading}
//               style={{ backgroundColor: 'rgb(77, 81, 168)' }}
//             >
//               <b>Existing User Login</b>
//             </Button>
//           </Form.Item>
//           <Form.Item>
//             <Link to="/RegForm">
//               <Button
//                 className="signup-link w-100"
//                 style={{ backgroundColor: 'rgb(49, 141, 106)' }}
//               >
//                 <b>Room Book / Apply</b>
//               </Button>
//             </Link>
//           </Form.Item>
//         </Form>
//       </div>
//     </div>
//   )
// }

// export default StudentLogin

import React, { useState } from 'react'
import { Form, Input, Button, Checkbox, notification, Modal, DatePicker } from 'antd'
import loginImage from './6878430.png'
import { Link } from 'react-router-dom'
import './alumini.css'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { MemberLoginApi, ForgotPasswordApi } from '../../ApiFile' // Add your forgot password API here
import dayjs from 'dayjs'
import { toast } from 'react-toastify'

const StudentLogin = () => {
  const [loading, setLoading] = useState(false)
  const [forgotVisible, setForgotVisible] = useState(false)
  const [forgotForm] = Form.useForm()
  const navigate = useNavigate()

  const onFinish = (values) => {
    setLoading(true)
    const currentYear = new Date().getFullYear()

    axios
      .post(MemberLoginApi, {
        email: values.username,
        password: values.password,
        loginYear: currentYear,
      })
      .then((response) => {
        setLoading(false)

        if (response.data.status == 5) {
          notification.warning({ message: 'Student is discharged!' })
          navigate('/StudentLogin')
          return
        } else if (response.data.message === 'Invalid Email_id') {
          notification.error({ message: 'Invalid Email' })
          return
        } else if (response.data.message === 'Invalid Password') {
          notification.error({ message: 'Invalid Password' })
          return
        }
        if (response.data.message === 'Login Successful') {
          sessionStorage.setItem('member_id', response.data.member_id)
          sessionStorage.setItem('memberName', response.data.memberName)
          sessionStorage.setItem('email', response.data.email)
          sessionStorage.setItem('status', response.data.status)
          sessionStorage.setItem('year', response.data.year)

          if (response.data.status === 3) {
            notification.warning({
              message: 'Admin Approval Pending',
              description: 'Wait for Admin Approval....',
            })
            navigate('/StudentLogin')
          } else if (response.data.status === 4) {
            notification.success({ message: 'Login Successfully !!!!!' })
            navigate('/BlockRoomBooking')
          } else if (response.data.status === 7) {
            notification.info({
              message: 'Payment Approval Pending',
              description: 'Admin payment approval is pending.',
            })
            navigate('/StudentLogin')
          } else if (response.data.status === 8) {
            sessionStorage.setItem('block_id', response.data.block_id)
            sessionStorage.setItem('room_id', response.data.room_id)
            sessionStorage.setItem('bed_id', response.data.bed_id)
            notification.error({
              message: 'Payment Rejected',
              description: 'Your payment has been rejected. Please pay again.',
            })
            navigate('/PaymentRoomBooking')
          } else if (response.data.status === 9) {
            navigate('/Homestudent')
          }
        } else {
          notification.error({
            message: 'Login Failed',
            description: 'Invalid email or password.',
          })
        }
      })
      .catch(() => {
        setLoading(false)
        notification.error({
          message: 'Login Failed',
          description: 'Error logging in. Please try again.',
        })
      })
  }

  const onFinishFailed = () => {}

  // Forgot Password Submit
  const handleForgotSubmit = (values) => {
    axios
      .put(ForgotPasswordApi, {
        email: values.email,
        dateofbirth: dayjs(values.dob).format('YYYY-MM-DD'),
      })
      .then((res) => {
        if (res.data.message === "INVALIDMEMBER") {
          toast.warning("Invalid Member Details!")
        }
        else if (res.data.message === "SEND") {
          toast.success("Password successfully send to your email!")
          forgotForm.resetFields()
          setForgotVisible(false)
        }
        
      })
      .catch(() => {
        notification.error({
          message: 'Error',
          description: 'Could not send reset request. Please try again.',
        })
      })
  }

  return (
    <div className="login-page">
      <div className="login-box" style={{ overflow: 'scroll' }}>
        <div className="illustration-wrapper">
          <img src={loginImage} alt="Login" />
        </div>
        <Form
          name="login-form"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <p className="form-title">Student Login</p>
          <p>Login to your student account</p>

          <Form.Item
            name="username"
            rules={[{ required: true, message: 'Please input your Email ID!' }]}
          >
            <Input placeholder="Email ID" />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password placeholder="Password" />
          </Form.Item>

          {/* Forgot Password Link */}
          <div style={{ textAlign: 'right', marginBottom: '10px' }}>
            <a onClick={() => setForgotVisible(true)} style={{ cursor: 'pointer' }}>
              Forgot Password?
            </a>
          </div>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button"
              loading={loading}
              style={{ backgroundColor: 'rgb(77, 81, 168)' }}
            >
              <b>Login</b>
            </Button>
          </Form.Item>
          <Form.Item>
            <Link to="/RegForm">
              <Button
                className="signup-link w-100"
                style={{ backgroundColor: 'rgb(49, 141, 106)' }}
              >
                <b>New Admission</b>
              </Button>
            </Link>
          </Form.Item>
        </Form>
      </div>

      {/* Forgot Password Modal */}
      <Modal
        title="Forgot Password"
        visible={forgotVisible}
        onCancel={() => {
          setForgotVisible(false)
          forgotForm.resetFields()
        }}
        footer={null}
      >
        <Form form={forgotForm} onFinish={handleForgotSubmit} layout="vertical">
          <Form.Item
            label="Email ID"
            name="email"
            rules={[{ required: true, message: 'Please enter your Email ID' }]}
          >
            <Input placeholder="Enter your Email ID" />
          </Form.Item>
          <Form.Item
            label="Date of Birth"
            name="dob"
            rules={[{ required: true, message: 'Please select your Date of Birth' }]}
          >
            <DatePicker className="w-100" format="YYYY-MM-DD" />
          </Form.Item>

          <div style={{ textAlign: 'right' }}>
            <Button
              onClick={() => {
                setForgotVisible(false)
                forgotForm.resetFields()
              }}
              style={{ marginRight: '8px' }}
            >
              Cancel
            </Button>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  )
}

export default StudentLogin

